module.exports = {
  ...require("./dialog.js"),
};
